<template>
  <div class="relative w-full h-[70vh]">
    <!-- Background Image -->
    <div class="absolute inset-0 overflow-hidden">
      <img
        src="../assets/images/HERO Pages ALL 2.png"
        alt="Background"
        class="w-full h-full object-cover"
      />
      <div class="absolute inset-0 bg-black opacity-50"></div>
    </div>

    <!-- Content Wrapper -->
    <div
      class="relative max-w-screen-4xl mx-auto h-full flex flex-col lg:flex-row items-center justify-center px-6 lg:px-32"
    >
      <h2
        class="text-white text-center text-3xl font-black animate__animated animate__backInLeft"
      >
        About Us
      </h2>
    </div>

    <!-- SVG Curve (Aligned to Background) -->
    <svg viewBox="0 0 1440 320" class="absolute bottom-0 left-0 w-full">
      <path
        fill="#ffffff"
        d="M0,224L80,208C160,192,320,160,480,176C640,192,800,256,960,266.7C1120,277,1280,235,1360,213.3L1440,192V320H0Z"
      ></path>
    </svg>
  </div>

  <!-- Who We Are (Moves Up Correctly) -->
  <div class="md:px-10 max-w-screen-4xl mx-auto relative z-10 mt-4 px-6 lg:-mt-20">
    <!-- Title Section -->
    <div class="strategic-card lg:px-14">
      <h2 class="text-yellow text-2xl who-style">Who We Are</h2>
    </div>

    <!-- Cards Section -->
    <div
      class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-14 mb-14"
    >
      <div
        v-for="(pillar, index) in strategicPillars"
        :key="index"
        class="strategic-card bg-secondary shadow-lg rounded-lg p-6 text-center cursor-pointer"
        style="will-change: transform, box-shadow"
      >
        <div class="flex justify-center items-center mb-4">
          <div
            class="bg-yellow w-12 h-12 flex items-center justify-center rounded-full"
          >
            <i :class="pillar.icon" class="text-white text-xl"></i>
          </div>
        </div>
        <h3 class="text-lg font-semibold text-black">{{ pillar.title }}</h3>
        <ul class="text-gray-900 mt-2">
          <li v-for="(desc, i) in pillar.description" :key="i" class="mb-2">
            {{ desc }}
          </li>
        </ul>
      </div>
    </div>
  </div>

  <div class="md:px-10 max-w-screen-4xl mx-auto px-6 lg:px-12 pb-10">
    <div class="row">
        <div class="card border-none">
          <img
            src="../assets/images/team.jpg"
            alt="Team Work"
            class="img-fluid rounded-lg h-96 w-full object-cover"
          />
        </div>
    </div>
  </div>

  <!-- Other section -->
  <aboutStory />
  <boardDirectors />
  <managementTeam />
  <faqSection />
</template>

<script>
import aboutStory from "../components/aboutStory.vue";
import boardDirectors from "../components/boardDirectors.vue";
import managementTeam from "../components/managementTeam.vue";
import faqSection from "../components/faqSection.vue";

export default {
  components: {
    aboutStory,
    boardDirectors,
    managementTeam,
    faqSection
  },
  data() {
    return {
      strategicPillars: [
        {
          title: "Our Vision",
          icon: "fa-regular fa-eye",
          description: [
            "To be the most exceptional real estate company empowering your dream of owning a home and a piece of the world",
          ],
        },
        {
          title: "Our Mission",
          icon: "fa-solid fa-paper-plane",
          description: [
            "We redefine your experience of what real estate value is and empower your dreams",
          ],
        },
        {
          title: "Our Core Values",
          icon: "fa-solid fa-ring",
          description: [
            "Impeccable Customer Satisfaction",
            "Honesty & Integrity",
            "Professionalism & Expertise",
          ],
        },
      ],
    };
  },
  mounted() {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("fade-in");
          } else {
            entry.target.classList.remove("fade-in");
          }
        });
      },
      {
        threshold: 0.2, // Adjust for smoother animation trigger
      }
    );

    document
      .querySelectorAll(".strategic-card")
      .forEach((card) => observer.observe(card));
  },
};
</script>

<style scoped>
svg path {
  fill: #ffffff !important;
  stroke: none !important;
  box-shadow: none !important;
}

svg {
  overflow: hidden !important;
}

.absolute.bottom-0 {
  line-height: 0 !important;
  padding-bottom: 0 !important;
  margin-bottom: -2px;
}

.overflow-hidden {
  overflow: hidden !important;
}

.who-style {
  font-family: Montserrat;
}

.strategic-card {
  opacity: 0;
  transform: translateY(50px);
  transition: opacity 1s ease-out, transform 1s ease-out;
  will-change: opacity, transform;
}

.strategic-card.fade-in {
  opacity: 1;
  transform: translateY(0);
}

.strategic-card:hover {
  transform: scale(1.03);
  /* box-shadow: 0 15px 30px rgba(0, 0, 0, 0.2); */
  transition: transform 0.4s ease-out, box-shadow 0.4s ease-out;
  /* background-color: inherit !important; */
  box-shadow: none !important;
}
</style>
